import React from 'react'
import data from "../../json/Template/TemplateContent.json";
import style from "./TemplateContent.module.css"
const TemplateContent = () => {
    return (
        <div className='container' >
            <div className={style.TemplatesPageContainer}>
                <div className={style.templatesContentContainer}>

                    <p className={style.Templateheadings}>{`{${data.heading}}`}</p>
                    <h2 className={style.TemplateCategory}>{data.Category}</h2>
                    <p className={style.TemplateDescription}>{data.description}</p>
                    <div className={style.searchContainer}>
                        <img src={process.env.PUBLIC_URL + "/NewPages/Homepage/searchIcon.png"} alt="Search" />
                        <input  className={style.searchtype} type="text" placeholder='Search "Journal articles"' />
                        <button>Search</button>
                    </div>

                </div>
                <div className={style.templateCardsHolder}>
                    <Card />
                </div>
            </div>
        </div>
    )
}

export default TemplateContent
export const Card = () => {
    return (
        <>
            {data.templates.map((item, index) => (
                <div className={style.TemplateCardContainer}>
                    <img src={process.env.PUBLIC_URL + item.image} alt="Logo" />
                    <h2>{item.title}</h2>
                    <p>{item.description}</p>
                </div>
            ))}
        </>
    )
}